import React from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { bool, func } from "prop-types";

import { Modal } from "shared/components";
import { Button } from "shared/components";

import IconMassive from "../../../../assets/svg/problema-area.svg";
import styles from "./styles.css";

const ModalMassive = ({ t, isCurrentStep, onPreviousStep, onReset }) => {
  return (
    <Modal isOpen={isCurrentStep} onClose={onReset}>
      <div className={styles.rootSuccess}>
        <img src={IconMassive} width="96px" alt="" />

        <p className={styles.textSuccess}>{t("MSG_0193")}</p>

        <div className={styles.actions}>
          <Button
            relevance="normal"
            type="submit"
            callToAction
            onClick={onReset}
          >
            {t("MSG_0111")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ModalMassive.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

ModalMassive.defaultPropTypes = {
  onClose: null,
};

const enhance = compose(translate());

export default enhance(ModalMassive);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalMassive/index.js